import { put, select, takeEvery, takeLatest } from 'redux-saga/effects'

import type { AppAction, AppState } from '@app/state'

import * as User from '../user/state'
import {
  getUserPreferences,
  patchUserPreferences,
} from '../user-preferences/user-preferences.interface'

import * as Today from './state'

function* handleLoadTodayStateFromLocalStorage() {
  yield takeEvery(
    User.ActionType.GetAccountInfoSucceeded,
    loadStateFromLocalStorage,
  )
}

function* loadStateFromLocalStorage(action: AppAction) {
  if (action.type === User.ActionType.GetAccountInfoSucceeded) {
    const appState: AppState = yield select((a) => a)
    const storedUserPreferences = getUserPreferences(action.userId)
    const storedTodayState = storedUserPreferences.today ?? {}
    yield put(
      Today.actions.setState({
        ...appState.today,
        ...storedTodayState,
      }),
    )
  }
}

function* handleSaveTodayStateToLocalStorage() {
  yield takeLatest(
    [
      Today.ActionType.SetLocationFilter,
      Today.ActionType.SetMrnFilter,
      Today.ActionType.SetPageNumber,
      Today.ActionType.SetPatientNameFilter,
      Today.ActionType.SetRecordsPerPage,
      Today.ActionType.SetSort,
      Today.ActionType.SetStatusFilter,
      Today.ActionType.SetTypeFilter,
    ],
    saveToLocalStorage,
  )
}

function* saveToLocalStorage(_action: AppAction) {
  const appState: AppState = yield select((a) => a)
  const userId = appState.user.account.userId
  patchUserPreferences(userId, {
    today: appState.today,
  })
}

export const sagas = {
  handleLoadTodayStateFromLocalStorage,
  handleSaveTodayStateToLocalStorage,
}
